import { TextFieldProps } from '@material-ui/core/TextField';

const MuiTextField: TextFieldProps = {
    variant: 'outlined',
};

export default MuiTextField;
